export default {
	name: "Nederlands",

	'global.itemCounts': `{total, plural,
		=0 {geen inhoud}
		other {}
	}{collections, plural,
		=0 {}
		one {een verzameling}
		other {{collections} verzamelingen}
	}{both, select,
		true {, }
		other {}
	}{stories, plural,
		=0 {}
		one {een verhaal}
		other {{stories} verhalen}
	}`,

	'cover.stories': `{itemCount, plural,
		one {verhaal}
		other {verhalen}
	}`,

	'searchbutton.placeholder': 'zoeken...',

	'flow.empty': 'Er is geen inhoud om weer te geven.',

	'search.empty': 'Uw zoekopdracht leverde geen resultaten op.',

	'forms.submitted': 'Uw inzendingen zijn succesvol ingediend.',
	'forms.errored': 'Er is een fout opgetreden bij het verzenden van uw gegevens.',
	'forms.required': 'Dit invoerveld is vereist om het formulier te verzenden.',
	'forms.close': 'dank u wel',

	'prevnext.prev': 'Vorig verhaal',
	'prevnext.next': 'Volgend verhaal',

	'navigation.back': 'terug',
	
	'share.back': 'terug',
	'share.embed': 'embed',
	'share.share': 'aandeel',
	'share.cover': 'Cover',
	'share.custom': 'eigen element',
	'share.inline': 'direct ingesloten',
	'share.customhere': 'VOEG HIER UW EIGEN PUNT IN',
	'share.scriptonce': 'Het bovenstaande script hoeft maar één keer per pagina te worden geïntegreerd',
	'share.FacebookLabel': 'Deel op Facebook',
	'share.TwitterLabel': 'tweet',
	'share.TwitterText': '{title}',
	'share.EmbedLabel': 'embed',

	'more.showCollection': 'Toon alle verhalen',
	'more.showMore': 'Toon oudere verhalen',
	'more.showMoreBack': '«',
	'more.showMoreSearch': 'Toon meer inhoud',
	'more.showMoreSearchBack': '«',

	'multislider.showAll': 'Toon alle verhalen',

	'passwordScreen.passwordPlaceholder': 'wachtwoord',
	'passwordScreen.usernamePlaceholder': 'gebruikersnaam',
	'passwordScreen.subTitle': 'is een {type, select, story {beschermd verhaal} collection {beschermde verzameling}}',
	'passwordScreen.submit': 'login',
	'passwordScreen.error': 'Inloggen is niet mogelijk!',

	'like.label': '{likeCount, number} Ik vind het leuk',
	'like.noLikeLabel': 'Ik vind het leuk',

};



// WEBPACK FOOTER //
// ./lib/locales/nl.js